import { RepositoryFactory } from "../../api/RepositoryFactory";
import i18n from "@/plugins/i18n";
const Repo = RepositoryFactory.get("signalTest");

export const signalTests = {
  namespaced: true,
  state: {
    currentTest: {},
    signalTests: [],
    testData: [],
  },

  mutations: {
    SET_TEST(state, test) {
      state.currentTest = test;
    },

    SET_TEST_DATAS(state, datas) {
      state.testData = datas;
    },

    SET_TESTS(state, tests) {
      state.signalTests = tests;
    },
  },

  actions: {
    async getTests({ commit, rootState, dispatch }) {
      var user = rootState.users.currentUser;
      var company = rootState.users.userCompany.companyId;
      if (company === undefined)
        await this.dispatch("users/getUserCompany", user, {
          root: true,
        });

      await Repo.getTests(user, company)
        .then((data) => {
          commit("SET_TESTS", data.data);
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), {
            root: true,
          });
        });
    },

    async peek({ commit, rootState, dispatch }, testId) {
      var user = rootState.users.currentUser;

      await Repo.peek(user, testId)
        .then((data) => {
          commit("SET_TEST_DATAS", data.data);
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), {
            root: true,
          });
        });
    },

    async getTest({ commit, rootState, dispatch }, testId) {
      var user = rootState.users.currentUser;

      await Repo.getTest(user, testId)
        .then((data) => {
          commit("SET_TEST", data.data);
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), {
            root: true,
          });
        });
    },

    async startTest({ commit, rootState, dispatch }, { deveui, payload }) {
      var user = rootState.users.currentUser;
      var company = rootState.users.userCompany.companyId;
      if (company === undefined)
        await this.dispatch("users/getUserCompany", user, {
          root: true,
        });

      await Repo.startTest(user, company, deveui, payload)
        .then((test) => {
          dispatch("getTests");
          commit("SET_TEST", test.data);
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), {
            root: true,
          });
        });
    },

    async endTest({ rootState, dispatch }, testId) {
      var user = rootState.users.currentUser;

      await Repo.endTest(user, testId)
        .then(() => {
          dispatch("getTests");
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), {
            root: true,
          });
        });
    },

    async deleteTest({ rootState, dispatch }, testId) {
      var user = rootState.users.currentUser;

      await Repo.deleteTest(user, testId)
        .then(() => {
          dispatch("getTests");
        })
        .catch(() => {
          dispatch("alert/error", i18n.t("common.error"), {
            root: true,
          });
        });
    },
  },
};
